// extracted by mini-css-extract-plugin
module.exports = {"reman-drawer__header":"reman-pop-up_reman-drawer__header__F7aFk","reman-drawer__body":"reman-pop-up_reman-drawer__body__f5qkZ"};